import { NOTES_MAX_LENGTH } from 'utils/customerNotes';

export const REVIEW_ORDER_ERRORS = {
  INVALID_DELIVERY_DATE: 'Please review and enter a valid delivery date.',
  INCOMPLETE_LOCATIONS:
    'Please complete delivery and return location details for every rental.',
  NOTES_TOO_LONG: `Please shorten comments and notes to ${NOTES_MAX_LENGTH} characters or less for every rental.`,
};
